import { Link } from "react-router-dom";
import { Truck, Mail } from "lucide-react";

const columns: { title: string; links: { label: string; to: string; external?: boolean }[] }[] = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "Pricing", to: "/pricing" },
      { label: "Driver App", to: "/features#driver-app" },
      { label: "Integrations", to: "/integrations" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Overview", to: "/solutions" },
      { label: "Vehicle Transport Software", to: "/solutions/vehicle-transport-software" },
      { label: "Small Businesses & Owner Drivers", to: "/vehicle-transport-software-for-small-businesses" },
      { label: "Industries", to: "/industries" },
      { label: "Subcontracting", to: "/solutions#subcontracting" },
      { label: "Compliance", to: "/solutions#compliance" },
    ],
  },
  {
    title: "POC & POD",
    links: [
      { label: "POC & POD Software", to: "/poc-pod-software" },
      { label: "Proof of Collection Software", to: "/proof-of-collection-software" },
      { label: "Proof of Delivery", to: "/features/proof-of-delivery" },
      { label: "ePOD Software", to: "/features/epod-software" },
    ],
  },
  {
    title: "Inspections",
    links: [
      { label: "Vehicle Inspection Software", to: "/vehicle-inspection-software" },
      { label: "Vehicle Damage Inspection Software", to: "/vehicle-damage-inspection-software" },
      { label: "Vehicle Condition Report Software", to: "/vehicle-condition-report-software" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Resource Hub", to: "/resources" },
      { label: "Guides & Comparisons", to: "/resources#guides" },
      { label: "Help Centre", to: "/help-centre" },
      { label: "FAQs", to: "/resources#faqs" },
    ],
  },

  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Start Free Trial", to: "/pricing#pricing" },
      { label: "Login", to: "/auth" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Delete Account", to: "/delete-account" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="border-t bg-card">
      <div className="container mx-auto px-4 py-12 sm:py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
                <Truck className="h-[18px] w-[18px] text-primary-foreground" />
              </span>
              <span className="font-bold tracking-tight">TransportMate</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
              Professional vehicle transport management for UK logistics companies — appraisals,
              tracking, proof of delivery and invoicing in one platform.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:contact@transportmate.co.uk"
                aria-label="Email TransportMate"
                className="h-11 w-11 rounded-lg border flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
            <a
              href="mailto:support@transportmate.co.uk"
              className="mt-3 inline-flex min-h-[44px] items-center text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              support@transportmate.co.uk
            </a>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className="font-semibold mb-3 text-sm">{col.title}</h2>
              <ul className="space-y-1 sm:space-y-2.5 text-sm text-muted-foreground">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="inline-flex min-h-[44px] items-center py-1 hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <p className="mt-10 border-t pt-6 text-center text-xs text-muted-foreground">
          Registered in England and Wales. Compliant with UK GDPR and the Data Protection Act 2018.
        </p>
      </div>
    </footer>
  );
}
